import React, { useEffect } from "react";
import ProductListWithVideo from "./components/ProductListWithVideo";
import Pagination from "../MyAccount/components/Pagination";
import SEO from "../../components/SEO";
import useProduct from "../../hooks/useProduct";

const ProductsWithVideo = () => {
  const { products, setHasVideo } = useProduct();

  // Ativa o filtro de vídeo ao entrar na página (antes do primeiro fetch)
  useEffect(() => {
    setHasVideo(true);
    return () => setHasVideo(false);
  }, [setHasVideo]);

  // Structured Data - ItemList para produtos com vídeo
  useEffect(() => {
    if (!products || products.length === 0) return;

    let itemListScript = document.querySelector('script[data-jsonld="itemlist-videos"]');
    if (!itemListScript) {
      itemListScript = document.createElement("script");
      itemListScript.setAttribute("type", "application/ld+json");
      itemListScript.setAttribute("data-jsonld", "itemlist-videos");
      document.head.appendChild(itemListScript);
    }

    const itemListSchema = {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "Produtos com Vídeo - Grupo Terra",
      description: "Lista de produtos que possuem materiais em vídeo para melhor compreensão",
      numberOfItems: products.length,
      itemListElement: products.map((product, index) => ({
        "@type": "ListItem",
        position: index + 1,
        item: {
          "@type": "Product",
          name: product.product_name,
          url: `${window.location.origin}/produto/${product.id}`,
          image: product.image,
        },
      })),
    };

    itemListScript.textContent = JSON.stringify(itemListSchema);

    return () => {
      const script = document.querySelector('script[data-jsonld="itemlist-videos"]');
      if (script) script.remove();
    };
  }, [products]);

  return (
    <>
      <SEO 
        title="Produtos com Vídeo - Materiais Complementares | Grupo Terra"
        description="Explore nossos produtos que possuem materiais em vídeo para melhor compreensão. Vídeos explicativos, tutoriais e demonstrações de produtos para mecânica pesada."
        keywords="produtos com vídeo, tutoriais, demonstrações, materiais complementares, vídeos explicativos, mecânica pesada"
      />
      <div className="container">
      <div className="row">
        <div className="col-12">
          <div style={{ marginBottom: "30px", marginTop: "20px" }}>
            <h1 className="ltn__primary-color" style={{ fontSize: "2rem", marginBottom: "10px" }}>Produtos com Vídeo</h1>
            <p style={{ color: "#666", marginTop: "10px", fontSize: "1.1rem" }}>
              Explore nossos produtos que possuem materiais em vídeo para melhor compreensão.
            </p>
          </div>
        </div>
      </div>
      <div className="row">
        <ProductListWithVideo />
      </div>
      <div
        style={{
          marginTop: "20px",
          marginBottom: "20px",
        }}
      >
        <Pagination />
      </div>
    </div>
    </>
  );
};

export default ProductsWithVideo;
